// src/main.tsx
// @ts-nocheck - Disable TypeScript checking for this file

import React from 'react'
import ReactDOM from 'react-dom/client'
import Modal from 'react-modal' // Импортируем react-modal
import App from './App'
import './index.css'
import './theme/globals.css'
import './styles/layout/responsive.css' // Добавляем наши новые адаптивные стили
import './locales/locales' // Import i18n configuration

// Устанавливаем корневой элемент для модальных окон
Modal.setAppElement('#root');

// Добавляем глобальную обработку ошибок для отладки
const handleError = (event: ErrorEvent) => {
  console.error('Global error handler:', event.error);
  // Можно добавить код для отправки ошибок на сервер или показа уведомления
};

window.addEventListener('error', handleError);

// Создаем отдельную функцию для инициализации приложения
const initApp = () => {
  try {
    const rootElement = document.getElementById('root');
    if (!rootElement) {
      console.error('Root element not found');
      return;
    }

    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  } catch (error) {
    console.error('App initialization error:', error);
  }
};

// Запускаем приложение после того, как DOM полностью загрузится
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}